<template>    
    <!--<div class="signup">-->
      <v-flex xs12 sm12 md12 lg12 xl12 class="signup">
        <v-container>
      <div class='pattern'></div>
        <v-layout class="tiranaranja" justify-end >          
          <img class="hidden-xs-only" src="elementos-pantalla-azulcielo-14.png" >
          <img class="hidden-sm-and-up" src="elementos-pantalla-azulcielo-14.png" height="150px" style="margin-top:30%">
        </v-layout>

        <v-layout class="divlogin" row justify-center >      
          <v-form v-model="valid" class="formlogin" style="background-color:#263971;  width:90%; border-radius:20px">
              <v-container>
                <v-layout row wrap justify-center class="pt-3">
                    <v-flex xs12 sm12 md4 lg5>
                      <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        label="usuario@gmail.com"
                        required
                        solo
                        prepend-inner-icon="person"
                        flat
                        style="background:white; border-radius:8px" class="pa-1"                        
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg5>   
                    <v-text-field
                        v-model="password"
                        :append-icon="show2 ? 'visibility' : 'visibility_off'"
                        :rules="[rules.required]"
                        :type="show2 ? 'text' : 'password'"
                        name="input-10-2"
                        label="Contraseña"
                        style="background:white; border-radius:8px;"
                        hint="At least 8 characters"
                        solo
                        prepend-inner-icon="lock"
                        flat
                        class="input-group--focused pa-1"
                        @click:append="show2 = !show2"                        
                      ></v-text-field>
                    <!-- Boton Recuperar Contraseña-->
                    <RecoverPassword></RecoverPassword>
                    <div class="hidden-xs-only"><br></div>
                  </v-flex>                  
                </v-layout>

                <v-layout justify-center>

                <!--Iniciar Sesion-->
                  <!--<LoginButton></LoginButton>-->
                  <v-btn
                    large
                    
                    class="text-none loginbutton"
                    color="#4ba96c"
                    dark
                    @click="login()"
                  >
                    Iniciar Sesión 
                  </v-btn>
                  
                </v-layout>
              </v-container>
            </v-form>
        </v-layout>

        <v-layout class="pl-5 mrosa" >
          <img class="hidden-xs-only" src="mrosa.png">
          <img class="hidden-sm-and-up" src="mrosa.png" height="150px">
        </v-layout>
        
  <!--</div>-->
        </v-container>
      </v-flex>

</template>


<script>

import RecoverPassword from "../components/RecoverPasswordButton"

export default {
    components:{
      RecoverPassword,      
    },

    data () {
      return {
        publicPath: process.env.BASE_URL,
        show2: false,
        valid:false,
        password: '',
        rules: {
          required: value => !!value || 'Required.',
          //min: v => v.length >= 8 || 'Min 8 characters',
          //emailMatch: () => ('The email and password you entered don\'t match')
        },
        email: '',
        emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
      }
      
    },
    methods:{
      login: function () {
        if(this.email=="" || this.password==""){
          alert("Llenar campos correctamente");
        } else{
          var trimmed_email = this.email.trim();
          trimmed_email = trimmed_email.toLowerCase();
         
          let datalogin = {
           user: trimmed_email,
           password: this.password,   
         }

       this.$store.dispatch('login', datalogin)
        .then(() =>         
              this.$router.push('/videos_capacitacion')  
              
        )
        .catch(function () {
           alert("Usuario/Contraseña incorrecto");
       })
    }}
    
}
}

</script>